import webApi from '../../WebApi/WebApi';


//Prohibition Recreational list
export const getAllProhibitionList = async () => {
    return await webApi.get(`/info-pages/slug/prohibition-of-recreational-substances-manual`);
}